module.exports = __webpack_public_path__ + "img/logo.2aef8e09.png";